// extracted by css-extract-rspack-plugin
export default {"cartFooterBanner":"cart-footer-banner--M2dfE5YcAM4WHbu_","cartFooterIcon":"cart-footer-icon--W3KRaJUAxUMoSQuQ"};